//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'BlogMenuItem',
  props: {
    cat: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      menuState: false
    }
  }
}
